<template>
<Row>
    <Col :span="20" :offset="2">
      <Alert type="warning" show-icon>
        重要提示
          <template slot="desc">
          请务必按照系统界定的eCRF设计模板，设计数据库文件。然后上传即可成功建库。该模板文件请勿随意调整列，只可根据具体情况增删行记录。详情见下载的模板文件。
          </template>
      </Alert>
    </Col>

    <Col :span="20" :offset="2">
      <Card>
        <p slot="title"><Icon type="ios-download" /> 下载eCRF设计模板文件</p>
        <div style="padding: 10px 0;">
          <Button type="default" icon="ios-cloud-download" @click="dowanload" size="large" long>
            eCRF 模板文件 design_tpl.xlsx
          </Button>
        </div>
      </Card>
    </Col>
    <Col :span="20" :offset="2">
      <Card>
        <p slot="title"><Icon type="ios-download" /> 上传eCRF设计的Excel文件</p>
        <div style="padding: 10px 0;">
          <Alert type="error" show-icon v-if="errors.length > 0">
              错误提示
              <span slot="desc">
                  <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
              </span>
          </Alert>
          <Spin class="loading-icon" v-if="loading">
            <Icon type="load-a" size=36 class="spin-icon-load" color="#ff9900"></Icon>
            <div>eCRF自动构建中，可能需要几十秒到几分钟，请耐心等待……</div>
          </Spin>
          <Alert type="success" show-icon v-if="finish">
              成功
              <span slot="desc">
                  在线eCRF构建已完成，需要变更，请点击设置。
              </span>
          </Alert>

          <Upload
            ref="uploader"
            :show-upload-list="false"
            :max-size="1024"
            :format="formats"
            :action="this.axios.defaults.baseURL + 'study/upload-excel?id=' + this.$route.params.id"
            :on-progress="onProgress"
            type="drag"
            :headers="this.axios.defaults.headers.common" :on-success="uploadSuccess" name="file_data">
                <div style="padding: 30px 0">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或拖拽设计完成的CRF的Excel文件上传即可建库</p>
                </div>
          </Upload>
        </div>
      </Card>
    </Col>
</Row>
</template>

<script>
import { DownloadTemplate } from '@/api/design'

export default {
  name: 'design-upload',
  data: function () {
    return {
      model: null,
      errors: [],
      formats: ['xlsx'],
      loading: false,
      finish: false
    }
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    uploadSuccess: function (res, file, fileList) {
      this.loading = false
      if (res.errors) {
        this.errors = res.errors
      } else {
        this.errors = []
        this.finish = true
        this.loading = false
        this.$Message.success('eCRF构建已完成')
      }
    },
    onProgress: function (event, file, fileList) {
      this.errors = []
      this.loading = true
    },
    dowanload: function () {
      DownloadTemplate().then(async res => {
        this.$Message.success('下载成功')
        const filetype = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        this.export(res, filetype, 'design_tpl.xlsx')
      })
    },
    export: function (res, type, filename) {
      let blob = new Blob([res], { type: type })
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      window.URL.revokeObjectURL(link.href)
      this.loading = false
    },
    fetchData: function () {
      this.axios.get('/study/view?id=' + this.$route.params.id)
        .then((res) => {
          this.model = res.data
        })
    }
  }
}
</script>
